/**
 * Fallback biometric-consent wording shown when an account hasn't set its own. Mirror of the server
 * default (services/lib/domain/consent.ts). Accounts with secure storage acknowledge this (or their
 * own override) before each stored capture.
 */
/*
 * Facial images are named EXPLICITLY rather than left to "related biometric identifiers".
 *
 * Several state biometric statutes treat face data as its own category, separate from fingerprints, and
 * the workflows can now capture and store a photograph of the subject. A statement that enumerates
 * fingerprints and then silently covers faces by implication is the kind of thing that reads badly in a
 * customer's legal review — and the subject signing it deserves to know what is being kept.
 */
export const DEFAULT_CONSENT_STATEMENT =
  'I authorize the collection, electronic capture, and storage of my fingerprints, my facial ' +
  'photograph, and related biometric identifiers for the purpose of this fingerprint submission. I ' +
  'understand that my biometric data, including my facial image, will be securely stored by the ' +
  'service provider and may be retained and used, including in de-identified or aggregated form, to ' +
  'operate, maintain, secure, and improve the service (including research, development, and quality ' +
  'assurance). I understand I may request deletion of my stored biometric data as described in the ' +
  'Privacy Policy.';
